import React from 'react';
import {styled, TextField, TextFieldProps} from '@mui/material';

const StyledColorPicker = styled((props: TextFieldProps) => (
  <TextField {...props} type="color" />
))(() => ({
  'width': '24px',
  'height': '24px',
  '& .MuiInputBase-root': {
    width: '24px',
    height: '24px',
    padding: 0,
    border: 'none',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  '& .MuiInputBase-input': {
    'width': '24px',
    'height': '24px',
    'padding': 0,
    'margin': 0,
    'border': 'none',
    'borderRadius': '4px',
    'cursor': 'pointer',
    'fontFamily': 'Brown LL',
    '&::-webkit-color-swatch-wrapper': {
      padding: 0,
    },
    '&::-webkit-color-swatch': {
      border: 'none',
      borderRadius: '4px',
    },
    '&::-moz-color-swatch': {
      border: 'none',
      borderRadius: '4px',
    },
  },
}));

export default StyledColorPicker;
